module.exports = __webpack_public_path__ + "static/img/1.4581cdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/1.png
// module id = POuN
// module chunks = 0